import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  button: {
    marginBottom: Theme.px(20),
  },
  pageTitleWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: Theme.px(20),
  },
  switchWrapper: {
    alignItems: 'center',
    // backgroundColor: Theme.withOpacity(Theme.white, 0.15),
    flexDirection: 'row',
    height: Theme.px(84),
    justifyContent: 'space-between',
    width: Theme.px(396),
  },
  checkIcon: {
    width: Theme.px(50),
    height: Theme.px(50),
  },
});
